export default "__VITE_ASSET__Bs8pKfyu__"